import {useContext} from "react";
import {UserContext} from "../context/UserContext";
import {SupportedThemes, UserInfo} from "../types/types";

export function useUserInfo() : {userInfo : UserInfo, updateUserInfo : (userInfo : Partial<UserInfo>) => void, handleThemeChange: (theme: SupportedThemes) => void, isMobile: boolean }{
    const userInfoHelpers = useContext(UserContext);
    return userInfoHelpers;
}
